import React from 'react';
import PricingComponent from '../../components/Pricing';
import Footer from './Footer';

function Pricing() {
  return (
    <div className="md:container pt-10 overflow-y-auto">
      <PricingComponent />
      <Footer />
    </div>
  );
}

export default Pricing;
